const withDefaultPxUnit = value => {
  return typeof value === 'number' ? `${value}px` : value;
};
const stringifyFontFamily = family => {
  return family.map(fontName => fontName.replace(/;$/, '')).map(fontName => fontName.includes(' ') ? JSON.stringify(fontName) : fontName).join(',');
};
export const getFontCssVars = (key, fontValue) => {
  if (!fontValue) {
    return {};
  }
  return {
    [key]: fontValue,
    [`${key}-style`]: fontValue == null ? void 0 : fontValue.style,
    [`${key}-variant`]: fontValue == null ? void 0 : fontValue.variant,
    [`${key}-weight`]: fontValue == null ? void 0 : fontValue.weight,
    [`${key}-size`]: withDefaultPxUnit(fontValue == null ? void 0 : fontValue.size),
    [`${key}-line-height`]: withDefaultPxUnit(fontValue == null ? void 0 : fontValue.lineHeight),
    [`${key}-family`]: fontValue != null && fontValue.family ? stringifyFontFamily(fontValue.family) : fontValue == null ? void 0 : fontValue.family,
    [`${key}-text-decoration`]: fontValue != null && fontValue.underline ? 'underline' : 'none'
  };
};
//# sourceMappingURL=getFontCssVars.js.map